<button
  mat-stroked-button
  type="button"
  class="ai-settings-panel-trigger"
  [matMenuTriggerFor]="aiSettings"
>
  <mat-icon class="size-s">settings</mat-icon>
  {{ 'guidedCourseCreation.outline.contentSettings' | translate }}
</button>

<mat-menu
  #aiSettings="matMenu"
  xPosition="before"
  class="ai-settings-panel-menu"
>
  <div class="ai-settings-panel" (click)="$event.stopPropagation()">
    <mat-slide-toggle
      [checked]="contentGenerationEnabled()"
      (change)="contentGenerationEnabled.set($event.checked)"
    >
      {{ 'guidedCourseCreation.outline.generateContent' | translate }}
    </mat-slide-toggle>

    @if (showContentMode()) {
      <div class="ai-settings-panel-mode">
        <app-segmented-toggle
          [options]="modeOptions"
          [value]="contentMode()"
          [ariaLabel]="'guidedCourseCreation.contentMode.label' | translate"
          (valueChange)="modeSelected.emit($event)"
        />
        <p class="ai-settings-panel-mode-description">
          {{ modeDescriptionKey() | translate }}
        </p>
      </div>
    }

    <mat-slide-toggle
      [checked]="imageGenerationEnabled()"
      (change)="imageGenerationEnabled.set($event.checked)"
    >
      {{ 'guidedCourseCreation.outline.generateImages' | translate }}
    </mat-slide-toggle>
  </div>
</mat-menu>
